import {
  GET_LOANTERM,
  GET_LOANTERM_SUCCESS,
  GET_LOANTERM_FAIL,
  DELETE_LOANTERM,
  DELETE_LOANTERM_SUCCESS,
  DELETE_LOANTERM_FAIL,
  UPDATE_LOANTERM,
  UPDATE_LOANTERM_SUCCESS,
  UPDATE_LOANTERM_FAIL,
  ADD_NEW_LOANTERM,
  ADD_LOANTERM_SUCCESS,
  ADD_LOANTERM_FAIL,
  LOANTERM_LOADING,
  LOANTERM_RESET,
} from "./actionType";

export const resetLoanTermState = (actionType) => ({
  type: LOANTERM_RESET,
  payload: { actionType },
});

export const getLoanTermSuccess = (actionType, data) => ({
  type: GET_LOANTERM_SUCCESS,
  payload: { actionType, data },
});

export const getLoanTermFail = (actionType, error) => ({
  type: GET_LOANTERM_FAIL,
  payload: { actionType, error },
});

export const getLoanTerm = data => ({
  type: GET_LOANTERM,
  payload: data,
});

export const getLoanTermLoading = () => ({
  type: LOANTERM_LOADING
});

export const deleteLoanTerm = data => ({
  type: DELETE_LOANTERM,
  payload: data,
});

export const deleteLoanTermSuccess = data => ({
  type: DELETE_LOANTERM_SUCCESS,
  payload: data,
});

export const deleteLoanTermFail = error => ({
  type: DELETE_LOANTERM_FAIL,
  payload: error,
});

export const updateLoanTerm = data => ({
  type: UPDATE_LOANTERM,
  payload: data,
});

export const updateLoanTermFail = error => ({
  type: UPDATE_LOANTERM_FAIL,
  payload: error,
});

export const updateLoanTermSuccess = data => ({
  type: UPDATE_LOANTERM_SUCCESS,
  payload: data,
});

export const addNewLoanTerm = data => ({
  type: ADD_NEW_LOANTERM,
  payload: data,
});

export const addLoanTermSuccess = data => ({
  type: ADD_LOANTERM_SUCCESS,
  payload: data,
});

export const addLoanTermFail = error => ({
  type: ADD_LOANTERM_FAIL,
  payload: error,
});